import { initials } from "../../utils/helper/managers";

/**
 * A manager's initials avatar, name and the tournament shown under the name (#133). Used by the
 * Managers page table, the Discover Managers widget and both confirmation dialogs, so the four
 * always present a manager the same way.
 */
export const ManagerIdentity = ({ manager, compact = false }) => (
  <div className={`manager-identity${compact ? " compact" : ""}`}>
    <span className="manager-initials" aria-hidden="true">
      {initials(manager?.fullName)}
    </span>
    <div className="manager-identity-text">
      <b>{manager?.fullName}</b>
      {manager?.tournamentName && <small>{manager.tournamentName}</small>}
    </div>
  </div>
);
